import React from "react";
import MainComponent from "../components/LandingPage/MainComponent";

function Home() {
  return (
    <>
      {/* <Header /> */}
      <MainComponent />
    </>
  );
}

export default Home;
